import { useEffect } from "react";

export default function SEO({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — DataMeridian Consulting` : "DataMeridian Consulting — Enterprise Database | Cloud | Data Engineering";
    document.title = fullTitle;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description || "Global consulting for SQL Server, PostgreSQL, Azure SQL, cloud migration, HA/DR, data engineering and 24×7 managed DBA services.");
    setMeta("theme-color", "#0A192F");
  }, [title, description]);
  return null;
}
